
<!--备用组件，根据接口查车辆详情-->
<template>
  <el-dialog
    v-model="dialogVisible"
    :title="showDetile ? '过车详情' : '一车一档'"
    width="80%"
    @close="closeDialog"
  >
    <template v-if="showDetile">
      <div class="carDetailDialog" v-loading="loading">
        <div class="first-content" v-if="dataInfo">
          <div class="left-card">
            <div
              class="left-card-top"
              @mouseover="mouseInImg"
              @mouseout="mouseOutImg"
              @mousemove="mouseMoveImg"
            >
              <img class="imgStyle" :src="dataInfo.storageUrlCloseShot" />
              <div class="shadowimg"></div>
              <div class="bigimg">
                <img
                  class="bigDetialStyle"
                  :src="dataInfo.storageUrlCloseShot"
                />
              </div>
            </div>
            <div class="left-card-bottom">
              <div class="Title">关联操作</div>
              <div class="left-card-bottom-content">
                <!-- <el-button type="primary">轨迹上图</el-button>
              <el-button type="primary">实时预览</el-button>
              <el-button type="primary">车辆布控</el-button> -->
                <el-button type="primary">以图搜车</el-button>
                <el-button type="primary" @click="downImgFile"
                  >图片下载</el-button
                >
                <el-button type="primary" @click="videoBack"
                  >录像回放</el-button
                >
              </div>
            </div>
          </div>
          <el-card class="tabs-card">
            <div class="tabsCard-content-left">
              <div class="Title">过车详情</div>
              <el-row>
                <el-col class="leftTitle" :span="12"
                  >车牌号码:&nbsp;&nbsp;{{ dataInfo.plateNo }}</el-col
                >
              </el-row>
              <el-row>
                <el-col class="leftTitle" :span="12"
                  >过车时间:&nbsp;&nbsp;{{ dataInfo.passTimeDesc }}</el-col
                ></el-row
              >
              <el-row>
                <el-col class="leftTitle" :span="24"
                  >抓拍地点:&nbsp;&nbsp;{{ dataInfo.deviceName }}</el-col
                ></el-row
              >
              <el-row>
                <el-col class="leftTitle" :span="12"
                  >过车速度:&nbsp;&nbsp;{{ dataInfo.speed }}</el-col
                ></el-row
              >
              <el-row>
                <el-col class="leftTitle" :span="12"
                  >车道编号:&nbsp;&nbsp;{{ dataInfo.laneNoDesc }}</el-col
                ></el-row
              >
              <el-row>
                <el-col class="leftTitle" :span="12"
                  >行驶方向:&nbsp;&nbsp;{{ dataInfo.directionDesc }}</el-col
                ></el-row
              >

              <div class="Title">识别信息</div>
              <el-row>
                <el-col class="leftTitle" :span="12"
                  >车标:&nbsp;&nbsp;{{}}</el-col
                >
              </el-row>
              <el-row>
                <el-col class="leftTitle" :span="12"
                  >车辆品牌:&nbsp;&nbsp;{{ dataInfo.vehicleBrandDesc }}</el-col
                >
              </el-row>
              <el-row>
                <el-col class="leftTitle" :span="12"
                  >子品牌:&nbsp;&nbsp;{{
                }}</el-col>
              </el-row>
              <el-row>
                <el-col class="leftTitle" :span="12"
                  >车辆年款:&nbsp;&nbsp;{{
                }}</el-col>
              </el-row>
              <el-row>
                <el-col class="leftTitle" :span="12"
                  >车辆类型:&nbsp;&nbsp;{{ dataInfo.vehicleClassDesc }}</el-col
                >
              </el-row>
              <el-row>
                <el-col class="leftTitle" :span="12"
                  >车身颜色:&nbsp;&nbsp;{{ dataInfo.vehicleColorDesc }}</el-col
                >
              </el-row>
              <el-row>
                <el-col class="leftTitle" :span="12"
                  >车牌颜色:&nbsp;&nbsp;{{ dataInfo.plateColorName }}</el-col
                >
              </el-row>
            </div>
            <div class="tabsCard-content-right">
              <!-- <div class="Title">车驾管信息</div> -->
              <!-- <el-row v-for="(item) in carMangeDetail" :key="item">
              <el-col class="leftTitle" :span="4">{{item.label}}</el-col>
              <el-col class="rightTitle" :span="4">{{item.value}}</el-col>
            </el-row> -->
              <div class="Title">车辆特征</div>
              <el-button type="warning" :disabled="true">{{
                dataInfo.tags ? dataInfo.tags[0].tagName : "暂无"
              }}</el-button>
              <div class="Title">车辆技战</div>
              <el-button type="primary" @click="carDetailRoute('落脚点')"
                >落脚点</el-button
              >
              <el-button
                v-show="routerName != 'carPeerAnalysis'"
                type="primary"
                @click="carDetailRoute('同行车')"
                >同行车</el-button
              >
              <el-button
                v-show="routerName != 'firstCity'"
                type="primary"
                @click="carDetailRoute('初次入城')"
                >初次入城</el-button
              >
              <el-button
                v-show="routerName != 'carOutNight'"
                type="primary"
                @click="carDetailRoute('昼伏夜出')"
                >昼伏夜出</el-button
              >
              <el-button
                v-show="routerName != 'deckAnalysis'"
                type="primary"
                @click="carDetailRoute('套牌车')"
                >套牌车
              </el-button>

              <div class="mapInfo">
                <MyMap ref="mapRef" />
              </div>
            </div>
          </el-card>
          <h-video-dialog
            v-if="videoDialogData && showVideoDialog"
            v-model:visible="showVideoDialog"
            :videoData="videoDialogData"
            :title="videoTitle"
          ></h-video-dialog>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="carArchivesDialog">
        <carArchives :itemInfo="carArchivesInfo"></carArchives>
      </div>
    </template>
    <h-icon
      class="icon you"
      icon="icon-xiangyoujiantou"
      font-size="36"
      @click="changeCpn"
    ></h-icon>
    <h-icon
      class="icon zuo"
      icon="icon-xiangzuojiantou"
      font-size="36"
      @click="changeCpn"
    ></h-icon>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  nextTick,
  watchEffect,
  onMounted,
} from "vue";
import MyMap from "@/components/map/MyMap.vue";
import {
  stopOveDetail,
  tollgateRecord,
} from "@/api/publicSecurityResearch/keyKehicles.js";
import { ElMessageBox, ElMessage } from "element-plus";
import util from "@util/js";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "carDetailDialogV1",
  components: { MyMap },
  props: {
    firstCityDetail: {
      type: Object,
      default: () => {
        return {};
      },
    },
    tableParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 展示弹窗
    visible: {
      type: Boolean,
      default: false,
    },
    itemInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    carArchivesInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  emits: ["closeDetial", "update:visible"],
  setup(props, { emit }) {
    const router = useRouter();
    const data = reactive({
      loading: false,
      showDetile: true,
      box: null,
      shadow: null,
      bigimg: null,
      dialogVisible: false,

      showDeckFirst: false,
      showDeckSecond: false,
      currentRow: null,
      dataInfo: null,
      routerName: "",
      showVideoDialog: false,
      videoDialogData: null,
      videoTitle: "",
    });
    const tableRef = ref(null);
    const refData = toRefs(data);
    const mapRef = ref();

    //使用wache监听不报红
    watchEffect(() => {
      data.dialogVisible = props.visible;
      console.log(props.carArchivesInfo);
      data.routerName = router.currentRoute.value.name;
    });
    const closeDialog = () => {
      emit("closeDetial");
      emit("update:visible", false);
    };
    //图片放大
    const mouseInImg = () => {
      data.box = document.querySelector(".left-card-top");
      data.shadow = document.querySelector(".shadowimg");
      data.bigimg = document.querySelector(".bigimg");
      data.big = document.querySelector(".bigDetialStyle");
      data.shadow.style.display = "block";
      data.big.style.display = "block";
    };
    const mouseOutImg = () => {
      data.shadow.style.display = "none";
      data.big.style.display = "none";
    };
    const mouseMoveImg = (e) => {
      let x = e.pageX - data.box.offsetLeft - 200;
      let y = e.pageY - data.box.offsetTop - 190;
      let width = x - data.shadow.offsetWidth / 2;
      let height = y - data.shadow.offsetHeight / 2;
      if (width <= 0) {
        width = 0;
      } else if (width >= data.box.offsetWidth - data.shadow.offsetWidth) {
        width = data.box.offsetWidth - data.shadow.offsetWidth;
      }
      if (height <= 0) {
        height = 0;
      } else if (height >= data.box.offsetHeight - data.shadow.offsetHeight) {
        height = data.box.offsetHeight - data.shadow.offsetHeight;
      }
      data.shadow.style.left = width + 20 + "px";
      data.shadow.style.top = height + 20 + "px";
      let big = document.querySelector(".bigDetialStyle");
      let bigx =
        (width * (big.offsetWidth - data.bigimg.offsetWidth)) /
        (data.box.offsetWidth - data.shadow.offsetWidth);
      let bigy =
        (height * (big.offsetHeight - data.bigimg.offsetHeight)) /
        (data.box.offsetHeight - data.shadow.offsetHeight);
      big.style.left = -bigx + "px";
      big.style.top = -bigy + "px";
    };

    const changeCpn = () => {
      data.showDetile = !data.showDetile;
    };
    //获取车辆详情
    const carDetailRoute = (val) => {
      if (val === "落脚点") {
        router.push({
          path: "carFootholdAnalysis",
          query: {
            plateNo: data.dataInfo.plateNo,
            plateColor: data.dataInfo.plateColor,
          },
        });
      } else if (val === "同行车") {
        router.push({
          path: "carPeerAnalysis",
          query: {
            plateNo: data.dataInfo.plateNo,
            plateColor: data.dataInfo.plateColor,
          },
        });
      } else if (val === "初次入城") {
        router.push({
          path: "firstCity",
          query: {
            plateNo: data.dataInfo.plateNo,
            plateColor: data.dataInfo.plateColor,
          },
        });
      } else if (val === "昼伏夜出") {
        router.push({
          path: "carOutNight",
        });
      } else if (val === "套牌车") {
        console.log(router);
        router.replace({
          path: "deckAnalysis",
          query: {
            plateNo: data.dataInfo.plateNo,
            plateColor: data.dataInfo.plateColor,
          },
        });
      }
      closeDialog();
    };
    //获取车辆详情
    const tollgateRecordAsync = async () => {
      data.loading = true;
      console.log(props.itemInfo);
      const params = {
        id: props.itemInfo.motorVehicleId,
      };
      const res = await tollgateRecord(params);
      data.dataInfo = res.data;
      data.loading = false;
      nextTick(() => {
        setTimeout(() => {
          pointInfoArray();
        });
      });
    };
    //添加接口中数据点位
    const pointInfoArray = () => {
      let pointInfo = {
        name: "",
        id: 1,
        type: 1,
        poiType: 3408,
        location: [],
        click: (e) => {},
      };
      pointInfo.location[0] = parseFloat(data.dataInfo.longitude);
      pointInfo.location[1] = parseFloat(data.dataInfo.latitude);
      nextTick(() => {
        mapRef.value && mapRef.value.loadMarker([pointInfo]);
        mapRef.value && mapRef.value.mapLocation(pointInfo.location, 14);
      });
    };
    //图片下载
    const downImgFile = () => {
      const url =
        "/imgApi/?" + data.dataInfo.storageUrlCloseShot.split("/?")[1];
      util.downImgFile(url);
    };
    // 视频回放
    const videoBack = () => {
      data.showVideoDialog = true;
      data.videoTitle = "视频回放";
      data.videoDialogData = data.dataInfo;
    };

    tollgateRecordAsync();
    return {
      ...refData,
      mapRef,
      tableRef,
      mouseInImg,
      mouseOutImg,
      mouseMoveImg,
      changeCpn,
      closeDialog,
      carDetailRoute,
      downImgFile,
      videoBack,
    };
  },
});
</script>
<style lang="scss" scoped>
.carDetailDialog {
  width: 100%;
  height: 65vh;
  position: relative;

  .first-content {
    width: 100%;
    height: 100%;
    display: flex;
    .Title {
      border-left: 3px solid #5584ff;
      font-size: 14px;
      color: #333;
      font-weight: bolder;
      height: 20px;
      line-height: 20px;
      padding-left: 8px;
      margin: 15px 0;
    }
    .left-card {
      width: 100%;
      height: 100%;
      width: 550px;
      padding: 20px;
      @include flex-col-c-s;
      /deep/.el-card__body {
        width: 100%;
      }
      .left-card-top {
        width: 100%;
        height: 70%;
        .imgStyle {
          width: 100%;
          height: 100%;
        }
        .shadowimg {
          position: absolute;
          top: 0;
          left: 0;
          height: 100px;
          width: 100px;
          background: #333;
          opacity: 0.7;
          border: 1px solid #333;
          display: none;
        }
        .bigimg {
          padding: 10px;
          height: 40%;
          width: 23%;
          overflow: hidden;
          margin-left: 10px;
          position: relative;
          position: absolute;
          left: 535px;
          top: 73px;
          z-index: 5;
          .bigDetialStyle {
            display: none;
            width: 500%;
            height: 500%;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
      .left-card-bottom {
        margin: 24px 0;
        .left-card-bottom-content {
          margin: 25px 10px;
          @include flex-row-s-e;
          flex-wrap: wrap;
          .el-button {
            margin: 15px;
          }
        }
      }
    }
  }

  .tabs-card {
    flex: 1;
    margin-left: 10px;
    /deep/ .el-card__body {
      flex-direction: row !important;
    }

    .el-row {
      margin: 8px 0 8px 16px;
    }
    .tabsCard-content-left {
      width: 50%;
      height: 100%;
    }
    .tabsCard-content-right {
      width: 50%;
      height: 100%;
      .mapInfo {
        border: 1px solid #fff;
        width: 100%;
        height: 60%;
        margin-top: 24px;
      }
    }
  }
}
.carArchivesDialog {
  height: 65vh;
}
.icon {
  position: absolute;
  top: 50%;
  color: #fff;
  cursor: pointer;
  &.you {
    right: -50px;
  }
  &.zuo {
    left: -50px;
  }
}
</style>
